"use client";

// Panneau de droite des pages inscription / connexion : un entrepreneur légendaire
// tiré AU HASARD à chaque montage de la page, avec sa photo en fond et son histoire
// de départ (garage / seul). Les photos sont à déposer dans public/static/believers/
// (mêmes noms de fichiers que ci-dessous). Tant qu'une photo manque, le panneau reste
// sombre et lisible (le dégradé + le texte suffisent).

import { useState, useEffect } from "react";

const BELIEVERS = [
    {
        name: "Brian Chesky",
        company: "Airbnb",
        tag: "Parti de rien",
        story: "Ils n'avaient plus de quoi payer le loyer. Alors ils ont loué trois matelas gonflables dans leur salon. C'est comme ça qu'Airbnb est né.",
        image: "/static/believers/brian-chesky.jpg",
    },
    {
        name: "Steve Jobs",
        company: "Apple",
        tag: "Dans un garage",
        story: "En 1976, il passait ses journées avec un ami dans un garage de Los Altos. Les premiers ordinateurs Apple, ils les ont assemblés à la main.",
        image: "/static/believers/steve-jobs.jpg",
    },
    {
        name: "Jeff Bezos",
        company: "Amazon",
        tag: "Dans un garage",
        story: "Il a démarré dans un garage, sur des portes en bois qui lui servaient de bureaux. Au début, Amazon ne vendait que des livres.",
        image: "/static/believers/jeff-bezos.jpg",
    },
    {
        name: "Walt Disney",
        company: "Disney",
        tag: "Dans un garage",
        story: "Un journal l'a renvoyé pour « manque d'imagination ». Puis il a fait faillite. Il est reparti de zéro dans le garage de son oncle.",
        image: "/static/believers/walt-disney.jpg",
    },
    {
        name: "Coco Chanel",
        company: "Chanel",
        tag: "Partie de rien",
        story: "Elle a grandi à l'orphelinat, sans un sou. Tout a commencé avec une petite boutique de chapeaux.",
        image: "/static/believers/coco-chanel.jpg",
    },
    {
        name: "Xavier Niel",
        company: "Free",
        tag: "Autodidacte",
        story: "Il a arrêté ses études après le bac. Il a commencé sur le Minitel, l'ancêtre d'Internet, puis il a créé Free.",
        image: "/static/believers/xavier-niel.jpg",
    },
    {
        name: "Justine Hutteau",
        company: "Respire",
        tag: "Partie de zéro",
        story: "À 23 ans, on lui a découvert une tumeur à la poitrine, heureusement bénigne. Alors elle a lancé Respire, un déodorant naturel. Son financement participatif a battu des records.",
        image: "/static/believers/justine-hutteau.jpg",
    },
    {
        name: "Sara Blakely",
        company: "Spanx",
        tag: "Toute seule",
        story: "Elle avait 5 000 dollars d'économies et aucune expérience. Elle a lancé Spanx, sa marque de sous-vêtements, dans son appartement.",
        image: "/static/believers/sara-blakely.jpg",
    },
    {
        name: "Larry Page & Sergey Brin",
        company: "Google",
        tag: "Dans un garage",
        story: "Ils ont loué un garage à Menlo Park pour y bricoler un moteur de recherche. Google est né.",
        image: "/static/believers/google.jpg",
    },
    {
        name: "Melanie Perkins",
        company: "Canva",
        tag: "Dans un salon",
        story: "Elle a commencé dans le salon de sa mère. Plus de cent investisseurs lui ont dit non. Elle n'a rien lâché.",
        image: "/static/believers/melanie-perkins.jpg",
    },
    {
        name: "Elon Musk",
        company: "Tesla, SpaceX",
        tag: "Parti de rien",
        story: "Pour lancer sa première boîte, il codait jour et nuit. Il dormait au bureau et allait se doucher à la salle de sport du coin.",
        image: "/static/believers/elon-musk.jpg",
    },
    {
        name: "Mark Zuckerberg",
        company: "Facebook",
        tag: "Dans une chambre d'étudiant",
        story: "À Harvard, il a codé un trombinoscope pour les étudiants du campus. C'était le début de Facebook.",
        image: "/static/believers/mark-zuckerberg.jpg",
    },
];

export default function BelieversPanel() {
    // On affiche le premier au premier rendu (évite un mismatch d'hydratation),
    // puis on bascule sur un tirage aléatoire une fois monté côté client.
    const [index, setIndex] = useState(0);

    useEffect(() => {
        setIndex(Math.floor(Math.random() * BELIEVERS.length));
    }, []);

    const believer = BELIEVERS[index];

    return (
        <div className="relative hidden md:block overflow-hidden bg-[#15161c]">
            {/* Photo en fond (fallback propre si le fichier n'existe pas encore) */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${believer.image})` }}
                aria-hidden="true"
            />
            {/* Dégradés pour la lisibilité (haut pour la phrase, bas pour la figure) */}
            <div className="absolute inset-x-0 top-0 h-1/3 bg-gradient-to-b from-black/70 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/90 via-black/45 to-transparent" />

            {/* Phrase de cadrage (fixe) : le pont vers l'utilisateur */}
            <div className="absolute inset-x-0 top-0 p-7">
                <p className="text-white text-xl font-semibold leading-snug mb-0 max-w-[85%]">
                    Ils l'ont fait. À votre tour.
                </p>
            </div>

            <div className="absolute inset-x-0 bottom-0 p-7">
                <div className="text-[11px] font-semibold uppercase tracking-[0.15em] text-primary mb-3">
                    {believer.tag}
                </div>
                <div className="text-white text-2xl font-bold leading-tight">
                    {believer.name}
                </div>
                <div className="text-primary/90 text-sm font-medium mb-3">
                    {believer.company}
                </div>
                <p className="text-white/85 text-[13.5px] leading-relaxed mb-0">
                    {believer.story}
                </p>
            </div>
        </div>
    );
}
